import { Pipe, PipeTransform } from '@angular/core';

export function getEntityTypeNameById(v: string): string {
  switch (true) {
    case v === '14115421-88f2-431a-8310-203c68180b33': {
      return 'Osoba fizyczna';
    }
    case v === '13d02d24-9e22-46f8-80ce-5d641fa8aeaa': {
      return 'Osoba fizyczna prow. dział. gosp.';
    }
    case v === '8172a696-2a3b-402a-b262-dfcf37404da3': {
      return 'Osoba prawna / JST';
    }
    case v === 'c6199647-b001-4d1f-a06e-9fbd7fb8cb39': {
      return 'Pozostałe podmioty'
    }
    default:
      return '';
  }
}

@Pipe({
  name: 'entityType',
  standalone: true
})
export class EntityTypePipe implements PipeTransform {

  public transform(v: string): string {
    return getEntityTypeNameById(v);
  }
}
